import {pull} from 'lodash';
import DatasetModel from './steps/dataset';

export default class PipelineModel {
    steps = []; // array of PipelineStepModel
    childMap = {};
    stepMap = {};
    executionOrder = [];
    results = {};

    constructor(pipelineData) {
        Object.assign(this, pipelineData, {steps: [], childMap: {}, stepMap: {}, executionOrder: []});
        if (pipelineData.steps) {
            pipelineData.steps.forEach((step) => { this.addStep(step); });
        }
    }

    addStep(step) {
        const parents = step.parents;
        step.pipeline = this;
        this.steps.push(step);
        this.stepMap[step.id] = step;
        let childId = null;
        if (parents.length) {
            let executionIndex = 0;
            for (const parentId of parents) {
                childId = this.childMap[parentId];
                this.childMap[parentId] = step.id;
                if (childId) {
                    const childStep = this.stepMap[childId];
                    pull(childStep.parents, parentId);
                    childStep.parents.push(step.id);
                }
                executionIndex = Math.max(executionIndex, this.executionOrder.indexOf(parentId) + 1);
            }
            this.executionOrder.splice(executionIndex, 0, step.id);
        } else {
            this.executionOrder.unshift(step.id);
        }
        this.childMap[step.id] = childId;
    }

    updateStep(step) {
        const index = this.steps.findIndex(({id}) => id === step.id);
        this.steps[index] = step;
        this.stepMap[step.id] = step;
    }

    addOrUpdateStep(step) {
        if (this.stepMap[step.id]) {
            this.updateStep(step);
        } else {
            this.addStep(step);
        }
    }

    removeStep(step) {
        pull(this.steps, step);
        pull(this.executionOrder, step.id);
        delete this.stepMap[step.id];
        for (const parent of step.parents) {
            this.childMap[parent] = this.childMap[step.id];
        }
        const child = this.stepMap[this.childMap[step.id]];
        if (child) {
            child.parents = step.parents.slice();
        }
        delete this.childMap[step.id];
    }

    getBranches() {
        return this.steps.filter(step => step instanceof DatasetModel).map(step => this.getBranchFrom(step));
    }

    getBranchFrom(step) {
        const pipeline = [step];
        let currentStep = step;
        while (currentStep && this.childMap[currentStep.id]) {
            currentStep = this.childMap[currentStep.id];
            if (currentStep) {
                currentStep = this.stepMap[currentStep];
                if (currentStep.parents.length > 1) {
                    // stop on a merge
                    currentStep = null;
                } else {
                    pipeline.push(currentStep);
                }
            }
        }
        return pipeline;
    }

    getResultForStep(step) {
        return this.results[typeof step === 'string' ? step : step.id];
    }

    getInputTableForStep(step) {
        return this.results[step.parents[0]].table;
    }

    run() {
        const pipelineResultsMap = {};
        for (const stepId of this.executionOrder) {
            const step = this.stepMap[stepId];
            const parentsTables = step.parents.map(parent => pipelineResultsMap[parent].table);
            pipelineResultsMap[step.id] = step.apply(parentsTables.length > 1 ? parentsTables : parentsTables[0]);
        }
        this.results = pipelineResultsMap;
        return pipelineResultsMap;
    }
}
